var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.724,
    height: 54.542,
    viewBox: "0 0 56.724 54.542",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b5b5b5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -9.136)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.136)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M55.769,320.728a3.153,3.153,0,0,0-2.318-.954H38.9a6.727,6.727,0,0,1-2.4,3.136,6.254,6.254,0,0,1-3.767,1.227H24a6.252,6.252,0,0,1-3.766-1.227,6.727,6.727,0,0,1-2.4-3.136H3.272a3.156,3.156,0,0,0-2.318.954A3.154,3.154,0,0,0,0,323.045v10.908a3.153,3.153,0,0,0,.954,2.318,3.156,3.156,0,0,0,2.318.954H53.452a3.258,3.258,0,0,0,3.272-3.272V323.045A3.153,3.153,0,0,0,55.769,320.728ZM42.986,332.215a2.141,2.141,0,1,1,.647-1.534A2.1,2.1,0,0,1,42.986,332.215Zm8.726,0a2.14,2.14,0,1,1,.648-1.534A2.1,2.1,0,0,1,51.713,332.215Z",
    transform: "translate(0 -282.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M93.285,28.772h8.727V44.044a2.212,2.212,0,0,0,2.182,2.182h8.728a2.212,2.212,0,0,0,2.181-2.182V28.772h8.727a2.037,2.037,0,0,0,2.011-1.364,1.939,1.939,0,0,0-.477-2.352L110.091,9.784a2.14,2.14,0,0,0-3.068,0L91.752,25.056a1.938,1.938,0,0,0-.477,2.352A2.038,2.038,0,0,0,93.285,28.772Z",
    transform: "translate(-80.195 -9.136)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b465a7e6442d4e41554b400fd07575cf.svg";
export { ForwardRef as ReactComponent };